import React, { useRef } from "react";
import { Button, Card, Tabs, } from "antd";
import WarehouseDetailForm from "./WarehouseForm";
import { ProfileTwoTone } from "@ant-design/icons";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import { useModelDispatchers } from "../../../models";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";


export default function () {
    const { closeNav } = useModelDispatchers("nav");
    const cRef = useRef();
    const save = () => {
        // changeVal就是子组件暴露给父组件的方法
        let ret = cRef.current.save();
    }
    const Title = ({ save }) => {
        const onSave = () => {
            cRef.current.insert();
        }
        const onReset = () => {
            cRef.current.reset();
        }
        const onClose = () => {
            closeNav();
        }


        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">新增仓库</span>
                </h3>
                <div style={{ width: "500px", textAlign: "right" }}>
                    <YhAuth resCode={ResourceAuthEnum.DATA_W_AD_SAVE}>
                        <Button type="primary" onClick={onSave}>保存</Button>
                    </YhAuth>
                    <Button className="margin-left-8" onClick={onReset}>重置</Button>
                    <Button className="margin-left-8" onClick={onClose}>关闭</Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            bordered={true}
            title={<Title save={save} />}
            className="margin-top-8"
        >
            <WarehouseDetailForm cRef={cRef} actionType={CM_ACTION_TYPE.INSERT} />
        </Card>
    )

};